
<script lang="ts">
  import { createEventDispatcher, getContext, onMount } from "svelte";
  import { VisioMapApp } from './visiomap';
  import { type ConnectMapEvent } from "../app";

  let element: HTMLElement;
  let promise: Promise<void>;

  const app = getContext<VisioMapApp>('app');
  const { T } = app;

  const dispatch = createEventDispatcher<ConnectMapEvent>()

  onMount(async () => {
    if (element) {
      promise = app.initialize(element, dispatch)
      const visiomap = await promise;
    }
  });
  
  function mouseout () {
    app.impl_layer.essential.content.resetHighlightedPlace();
  }

</script>

<div 
  bind:this={element}
  on:mouseout={mouseout}
  on:blur={mouseout}>
  {#await promise}
    <div class="msg" style="text-align:center;">{$T`loading`}</div>
  {:catch error}
    <div class="msg">
      <strong>{$T`error_title`}</strong>
      <pre>{error}</pre>
    </div> 
  {/await}
</div>

<style>
  .msg {
    display: flex;
    height: 100%;
    padding: var(--_p4);
    flex-direction: column;
    justify-content: center;
    color: #000;
  }

  pre {
    white-space: normal;
  }
</style>